import React, { forwardRef } from 'react';
import './filter-select.scss';
export var FilterSelect = forwardRef(function (_a, ref) {
    var id = _a.id, options = _a.options, forceSelection = _a.forceSelection, placeHolder = _a.placeHolder, required = _a.required, disabled = _a.disabled, error = _a.error, onChange = _a.onChange, value = _a.value;
    var selectClasses = 'c-form-select';
    if (error) {
        selectClasses += ' isInvalid';
    }
    if (required) {
        selectClasses += ' isRequired';
    }
    if (value) {
        selectClasses += ' isFiltered';
    }
    return (React.createElement("div", { className: "c-input-select-wrapper" },
        React.createElement("select", { name: id, id: id, className: selectClasses, ref: ref, placeholder: placeHolder, disabled: disabled, required: required, "aria-invalid": error ? 'true' : 'false', "data-testid": "filter-select", onChange: onChange, defaultValue: "0" },
            forceSelection && (React.createElement("option", { value: "0", disabled: true, hidden: true }, placeHolder)),
            options.map(function (option) {
                var _a, _b;
                return (React.createElement("option", { key: option.id, value: option.id, disabled: ((_a = option.selectable) !== null && _a !== void 0 ? _a : true) ? false : true }, (_b = option.displayText) !== null && _b !== void 0 ? _b : option.value));
            }))));
});
FilterSelect.displayName = 'FilterSelect';
